import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AUTH_SILENT_ATTEMPTED_KEY } from '../../shared/services/token.util';

/** Legacy route — always send users to the custom login page (home). */
@Component({
  selector: 'app-error',
  template: '',
})
export class ErrorComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    sessionStorage.setItem(AUTH_SILENT_ATTEMPTED_KEY, '1');
    this.router.navigateByUrl('/', { replaceUrl: true });
  }
}
